import { FunctionComponent } from 'react';
import './sub-menu.scss';
import { FeatureMenuItems, Languages } from '../../features/feature-menu';
import { ShowcasesMenuItems } from '../../showcases/showcases-menu';
import LI from '../html-tags/li';

export type Props = {
  selected?: FeatureMenuItems | ShowcasesMenuItems;
  menuName: FeatureMenuItems | ShowcasesMenuItems;
  labels: { language: Languages; label: string }[];
};

const SubMenuItem: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <>
      {props.labels
        .filter((x) => window.location.href.indexOf('/' + x.language + '/') !== -1)
        .map((languageInfo) => (
          <LI
            key={languageInfo.language}
            language={languageInfo.language}
            className={props.selected === props.menuName ? 'selected' : ''}
          >
            <a href={'/' + languageInfo.language + '/' + props.menuName}>
              <span>{languageInfo.label}</span>
            </a>
          </LI>
        ))}
    </>
  );
};

export default SubMenuItem;
